<template>
  <div>
    <ListingHeader :listing="listing" />

    <div class="container">
      <ContactOwnerButtons />

      <GalleryTabs
        :images="listing.images"
        :files="listing.files"
        :vr="listing.properties.vr"
        :youtubeVideoId="listing.properties.youtubeVideoId"
      />

      <IconProperties :elements="computeIconProperties" />

      <!-- DESCRIPTION START-->
      <div class="row">
        <div class="col-md-12">
          <h3>{{ this.computeTitle }}</h3>
        </div>
        <div class="col-md-12">
          <!-- 
            DO NOT REMOVE: If this comment is removed, prettier will force the content of the html tag on the next line
            Since the element has a pre-wrap value, it will create an issue where the text is indented!
           -->
          <!-- prettier-ignore -->
          <p style="white-space: pre-wrap">{{ listing.longDescription | localized }}</p>
        </div>
      </div>

      <div class="row" v-if="listing.externalUrl">
        <div class="col text-center">
          <external-link :link="listing.externalUrl"></external-link>
        </div>
      </div>

      <ListingTable :listing="listing" />

      <MapsTabs
        :coordinates="coordinates"
        :streetView="listing.properties.googleStreetView"
      />

      <StaticPrices :prices="listing.prices">
        <SpecialOffer
          v-if="
            listing.specialOffer !== undefined && listing.specialOffer !== null
          "
          :specialOffer="listing.specialOffer"
        ></SpecialOffer>
      </StaticPrices>

      <!-- Booking widget -->
      <hr class="solid" />
      <div class="row">
        <div class="col-md-12">
          <h3 class="mb-3 mt-2" style="margin-bottom: 30px !important">
            {{ $t("views.listing.titles.book") }}
          </h3>
        </div>
      </div>
      <!-- <BookingWidget :listing="listing"></BookingWidget> -->
      <StaticBookingWidget
        :listing="listing"
        id="availabiltyContainer"
      ></StaticBookingWidget>

      <RenterContact :listing="listing" />

      <RelatedListings :forId="listingId" />
    </div>
  </div>
</template>

<script>
import IconProperties from "@/components/level3/IconProperties.vue";
import ContactOwnerButtons from "@/components/level3/ContactOwnerButtons.vue";
import MapsTabs from "@/components/MapsTabs";
import ListingTable from "@/components/level3/ListingTable";
import RenterContact from "@/components/level3/RenterContact";
import ListingHeader from "@/components/level3/ListingHeader";
import GalleryTabs from "@/components/level3/GalleryTabs";
import RelatedListings from "@/components/level3/RelatedListings";
import SimpleDate from "@/components/level3/SimpleDate";
import BookingWidget from "@/components/level3/BookingWidget";
import StaticPrices from "@/components/level3/StaticPrices";
import StaticBookingWidget from "@/components/level3/StaticBookingWidget";
import SpecialOffer from "@/components/level3/SpecialOffer";
import ExternalLink from "@/components/level3/ExternalLink.vue";

export default {
  name: "ListingDetailView",
  components: {
    IconProperties,
    ContactOwnerButtons,
    MapsTabs,
    ListingTable,
    RenterContact,
    ListingHeader,
    GalleryTabs,
    RelatedListings,
    SimpleDate,
    BookingWidget,
    StaticPrices,
    StaticBookingWidget,
    SpecialOffer,
    ExternalLink,
  },
  computed: {
    listing: function () {
      return this.$store.getters.getCurrentListing;
    },
    listingId: function () {
      if (this.isUndefined(this.listing)) {
        return;
      }
      return Number(this.listing.id);
    },
    coordinates: function () {
      if (
        this.isUndefined(this.listing) ||
        this.isUndefined(this.listing.address)
      ) {
        return { lat: 46.0037, lng: 8.9511 };
      }

      return {
        lat: this.listing.address.latitude,
        lng: this.listing.address.longitude,
      };
    },
    computeIconProperties() {
      if (this.listing !== {} && this.listing.properties !== {}) {
        return [
          {
            icon: "fas fa-home",
            name: this.listing.houseType.localizedName[this.$i18n.locale],
          },
          {
            icon: "fas fa-bed",
            name:
              this.listing.properties.numberOfBedrooms +
              " " +
              this.$i18n.tc(
                "components.iconProperties.bedroom",
                this.listing.properties.numberOfBedrooms
              ),
          },
          {
            icon: "fas fa-users",
            name:
              this.listing.properties.numberOfPeople +
              " " +
              this.$i18n.tc(
                "components.iconProperties.people",
                this.listing.properties.numberOfPeople
              ),
          },
          {
            icon: "fas fa-vector-square",
            name: this.listing.properties.surface,
            additional: " m<sup>2</sup>",
          },
          {
            icon: "fas fa-bath",
            name:
              this.listing.properties.bathroomCount +
              " " +
              this.$i18n.tc(
                "components.iconProperties.bathroom",
                this.listing.properties.bathroomCount
              ),
          },
        ];
      } else {
        return [];
      }
    },
    computeTitle: function () {
      // {{ listing.name }} in {{ listing.address.city }}
      if (
        this.isUndefined(this.listing) ||
        this.isUndefined(this.listing.address)
      ) {
        console.log("Undefined");
        return;
      }
      let locale = this.$i18n.locale || "de";
      let houseType = this.listing.houseType.localizedName[locale];

      return `${houseType} in ${this.listing.address.city}`;
    },
  },
  methods: {
    fetchListing: function () {
      const objectId = this.$route.params.id;
      console.log("Getting listing with object Id " + objectId);

      let url = "/listings/objectId/" + objectId;

      this.$http
        .get(url)
        .then((res) => {
          this.myData = res.data;
          if (this.myData === undefined) {
            console.log("ERROR FETCHING THE OBJ!");
            this.$router.push("/not-found");
          }
          // From here, we call the visit log
          this.logVisit(res.data.objectId);
        })
        .catch((err) => {
          console.log(err);
          console.log("Listing => ERROR");
          this.$router.push("/not-found");
        });
    },
    logVisit: function (objectId) {
      this.$http
        .post(`/visits?objectId=${objectId}`)
        .then((res) => {
          // We do not really care about the result
          console.log(`Registered View for obj ${objectId}`);
        })
        .catch((err) => {
          let error = this.getErrorMessage(err);
          console.log(`Could not register view. Reason ${error}`);
        });
    },
    parseOpenBookingRequest: function () {
      // OpenBooking. Parse the parameters
      let partnerId = this.$route.query.partnerId;
      let checkin = this.$route.query.checkin;
      let checkout = this.$route.query.checkout;
      let adults = this.$route.query.adults;
      let language = this.$route.query.language;
      let currency = this.$route.query.currency;
      let children = this.$route.query.children;

      if (!this.isUndefined(partnerId)) {
        // Invalidate the current query. This is because we know the request is external
        this.$store.commit("resetQuery");
      }

      // Get the base query
      let query = this.getEditable(this.$store.getters.getQuery);

      // Start by parsing the dates
      if (!this.isUndefined(checkin)) {
        let startDate = this.castDate(checkin);
        // get the query and set the start date
        query.selectedDates.start = startDate;
      }

      if (!this.isUndefined(checkout)) {
        let endDate = this.castDate(checkout);
        // get the query and set the start date
        query.selectedDates.end = endDate;
      }

      // Parse the occupants
      if (!this.isUndefined(adults)) {
        query.numberOfAdults = parseInt(adults);
      }

      if (!this.isUndefined(children)) {
        query.numberOfKids = parseInt(children);
      }

      // Push the query to the store
      this.$store.commit("setQuery", query);
    },
  },
  mounted() {
    const objectId = this.$route.params.id;
    this.logVisit(objectId);

    // Check if we have a source for the URL
    let source = this.$route.query.source;
    if (!this.isUndefined(source)) {
      // Depending on the source, activate the different params
      if (source === "ob") {
        this.parseOpenBookingRequest();
      }
    }
  },
};
</script>
